export enum NumberGenerationType {
  PackList = 'PackList',
  SaleOrder = 'SaleOrder',
  PurchaseOrder = 'PurchaseOrder',
  Invoice = 'Invoice',
  CancelInvoice = 'CancelInvoice',
  Customer = 'Customer',
}
